<template>
    <v-sheet class="py-3" width="100%">
        <v-divider class="white my-2"></v-divider>
        <v-row class="pa-0 mx-4" no-gutters>
            <v-col class="d-flex justify-center align-center" cols="5">
                <span
                    class="d-inline-block rounded-circle overflow-hidden"
                    :style="{ 'width': imgWidth+'px', 'height': imgWidth+'px' }">
                    <v-img
                        :src="bnfcrImg" :width="imgWidth" :height="imgWidth"
                        position="center center">
                    </v-img>
                </span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="py-7" cols="6">
                <v-row class="pa-0" no-gutters>
                    <span class="fontOneToOne font-weight-medium">
                        {{ bnfcrInfo.name }} &#40; {{ bnfcrInfo.gndr }} / {{ bnfcrInfo.age }}세 &#41;
                    </span>
                </v-row>
                <v-divider class="white my-1"></v-divider>
                <v-row class="pa-0" no-gutters>
                    <v-chip class="" color="blue105" small>
                        <span class="fontOne font-weight-medium white--text mx-1" >
                            {{ bnfcrInfo.entStcdNm }}
                        </span>
                    </v-chip>
                </v-row>
            </v-col>
        </v-row>
        <v-divider class="white my-3"></v-divider>
        <v-row class="pa-0 mx-5" no-gutters>
            <v-col cols="12">
                <span class="overflow-x-auto">
                    <v-tabs
                        class="cstTabs slideHgt-2 white" slider-size="1" height="40"
                        v-model="tab" show-arrows>
                        <v-tabs-slider color="blue105"></v-tabs-slider>
                        <v-tab
                            active-class="blue105--text"
                            v-for="(tb, i) in tabMenu" :key="i">
                            <span class="fontOne mx-1">{{ tb.tbNm }}</span>
                        </v-tab>
                    </v-tabs>
                </span>
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
                <v-tabs-items v-model="tab" touchless>
                    <v-divider class="white my-2"></v-divider>
                    <v-tab-item transition="false">
                        <v-row class="pa-0" no-gutters>
                            <span class="fontOneToOne font-weight-medium">기본항목</span>
                        </v-row>
                        <v-divider class="black mt-2"></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">건강검진 제출일</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.entHlthChdt }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">생신일</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.rsdntBirth }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">생활실</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.lvnRm }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">입소일</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.entDt }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">생년월일</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.birth }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">본인부담률</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.copayRate }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR" style="padding-top: 7px;" cols="5">
                                <span class="fontOne">보조금</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 7px;" cols="7">
                                <v-chip
                                    class="px-1 mr-2"
                                    :color="bnfcrInfo.snackSprtYn ? 'blue105' : ''"
                                    :text-color="bnfcrInfo.snackSprtYn ? 'white' : ''"
                                    label small>
                                    간식비
                                </v-chip>
                                <v-chip
                                    class="px-1"
                                    :color="bnfcrInfo.mealSprtYn ? 'blue105' : ''"
                                    :text-color="bnfcrInfo.mealSprtYn ? 'white' : ''"
                                    label small>
                                    식사재료비
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">인정번호</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.acknwNum }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 tableBR d-flex align-center justify-center" cols="5">
                                <span class="fontOne">인정등급/기간</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px; line-height: 1.3;" cols="7">
                                <span class="fontOne">
                                    {{ bnfcrInfo.acknwRtng }} &#40; {{ bnfcrInfo.acknwPrdStrt }} ~ {{ bnfcrInfo.acknwPrdEnd }} &#41;
                                </span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">휴대폰</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.celphn }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 tableBR d-flex align-center justify-center" cols="5">
                                <span class="fontOne">주소</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px; line-height: 1.3;" cols="7">
                                <span class="fontOne">
                                    &#40; {{ bnfcrInfo.zip }} &#41; {{ bnfcrInfo.addr }} {{ bnfcrInfo.addrDtl }}
                                </span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">전화번호</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.tel }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 tableBR d-flex align-center justify-center" cols="5">
                                <span class="fontOne">주요질환</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px; line-height: 1.3;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.majorDsss }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 tableBR d-flex align-center justify-center" cols="5">
                                <span class="fontOne">비고</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px; line-height: 1.3; word-break: break-all;" cols="7">
                                <span class="fontOne">{{ bnfcrInfo.rmrks }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-divider class="white my-2"></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <span class="fontOneToOne font-weight-medium">보호자 정보</span>
                        </v-row>
                        <v-divider class="black mt-2"></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">보호자명</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ galFmlyInfo.name }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">생년월일</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ galFmlyInfo.rltns }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">관계</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <span class="fontOne">{{ galFmlyInfo.rsdntBirth }}</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                <span class="fontOne">휴대폰</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                <a class="fontOne" :href="'tel:'+galFmlyInfo.celphn">{{ galFmlyInfo.celphn }}</a>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <v-col class="nmlBfClr-grey001 tableBR d-flex align-center justify-center" cols="5">
                                <span class="fontOne">주소</span>
                            </v-col>
                            <v-col class="pt-1 px-4" style="padding-bottom: 5px; line-height: 1.3;" cols="7">
                                <span class="fontOne">
                                    &#40; {{ galFmlyInfo.zip }} &#41; {{ galFmlyInfo.addr }} {{ galFmlyInfo.addrDtl }}
                                </span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <div v-for="(fmly, j) in fmlyList" :key="j">
                            <v-divider class="black mt-4"></v-divider>
                            <v-row class="pa-0" no-gutters>
                                <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                    <span class="fontOne">이름</span>
                                </v-col>
                                <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                    <span class="fontOne">{{ fmly.name }}</span>
                                </v-col>
                            </v-row>
                            <v-divider class=""></v-divider>
                            <v-row class="pa-0" no-gutters>
                                <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                    <span class="fontOne">관계</span>
                                </v-col>
                                <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                    <span class="fontOne">{{ fmly.rltns }}</span>
                                </v-col>
                            </v-row>
                            <v-divider class=""></v-divider>
                            <v-row class="pa-0" no-gutters>
                                <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                    <span class="fontOne">휴대폰</span>
                                </v-col>
                                <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                    <span class="fontOne">{{ fmly.celphn }}</span>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-2"></v-divider>
                        </div>
                    </v-tab-item>
                    <v-tab-item transition="false">
                        <AppYMD
                            class="mx-1"
                            :aplyMinDt="'2020-01-01'" :aplyMaxDt="$moment().format('YYYY-MM-DD')"
                            @sltHypDt="getHypDt">
                        </AppYMD>
                        <v-divider class="mt-3"></v-divider>
                        <div v-if="hlthVtlRecList.length > 0">
                            <div v-for="(rec, k) in hlthVtlRecList" :key="k" class="mx-1">
                                <v-divider class="white my-2"></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <span class="fontOneToOne font-weight-medium">{{ k+1 }}회차</span>
                                </v-row>
                                <v-divider class="black mt-2"></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                        <span class="fontOne">시간 &#40; 필요시 &#41;</span>
                                    </v-col>
                                    <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                        <span class="fontOne">{{ rec.obsrvTmHh }}</span>
                                        <span v-if="rec.obsrvTmMm != '' && rec.obsrvTmMm != null" class="fontOne mx-1">:</span>
                                        <span class="fontOne">{{ rec.obsrvTmMm }}</span>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                        <span class="fontOne">혈압 &#40; 고 / 저 &#41;</span>
                                    </v-col>
                                    <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                        <span class="fontOne">{{ rec.bldPrsH }}</span>
                                        <span v-if="rec.bldPrsL != '' && rec.bldPrsL != null" class="fontOne mx-1">/</span>
                                        <span class="fontOne">{{ rec.bldPrsL }}</span>
                                        <span v-if="rec.bldPrsL != '' && rec.bldPrsL != null" class="fontOne ml-1">mmHg</span>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                        <span class="fontOne">맥박</span>
                                    </v-col>
                                    <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                        <span v-if="rec.pulse != ''" class="fontOne">분당 {{ rec.pulse }}회</span>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                        <span class="fontOne">체온</span>
                                    </v-col>
                                    <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                        <span class="fontOne">{{ rec.tmprt }}</span>
                                        <span v-if="rec.tmprt != ''" class="fontOne ml-1">℃</span>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                        <span class="fontOne">호흡</span>
                                    </v-col>
                                    <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                        <span v-if="rec.rsprt != ''" class="fontOne">분당 {{ rec.rsprt }}회</span>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                        <span class="fontOne">혈당</span>
                                    </v-col>
                                    <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                        <span class="fontOne">{{ rec.bldSgr }}</span>
                                        <span v-if="rec.bldSgr != ''" class="fontOne ml-1">mg/dL</span>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="5">
                                        <span class="fontOne">체중</span>
                                    </v-col>
                                    <v-col class="pt-1 px-4" style="padding-bottom: 5px;" cols="7">
                                        <span class="fontOne">{{ rec.wght }}</span>
                                        <span v-if="rec.wght != ''" class="fontOne ml-1">kg</span>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                            </div>
                        </div>
                        <v-row v-else class="pa-0 tableBB" no-gutters>
                            <v-col class="txtAlgnMid px-2 pt-2" style="padding-bottom: 10px;" cols="12">
                                <span class="fontDotEight">조회된 바이탈 기록이 없습니다.</span>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item transition="false">
                        <AppYMD
                            class="mx-1"
                            :aplyMinDt="'2020-01-01'" :aplyMaxDt="$moment().format('YYYY-MM-DD')"
                            @sltHypDt="getHypDt">
                        </AppYMD>
                        <v-divider class="mt-3"></v-divider>
                        <v-divider class="white my-2"></v-divider>
                        <v-row class="pa-0" no-gutters>
                            <span class="fontOneToOne font-weight-medium">투약상황 기록</span>
                        </v-row>
                        <v-divider class="black mt-2"></v-divider>
                        <v-row v-for="(rec, m) in doesRecList" :key="m" class="pa-0 tableBB" no-gutters>
                            <v-col
                                class="nmlBfClr-grey001 overflow-text-hidden d-flex align-center tableBR px-2" cols="6">
                                <span class="fontOne">{{ rec.drugNm }}</span>
                            </v-col>
                            <v-col class="px-4" style="padding-top: 6px; padding-bottom: 7px;" cols="6">
                                <v-row class="pa-0" no-gutters>
                                    <v-chip
                                        class="px-1 mr-2"
                                        :color="rec.dsBrkfsBf == '1' ? 'blue105' : ''"
                                        :text-color="rec.dsBrkfsBf == '1' ? 'white' : ''"
                                        label small>
                                        아침식전
                                    </v-chip>
                                    <v-chip
                                        class="px-1 mr-2"
                                        :color="rec.dsBrkfsAf == '1' ? 'blue105' : ''"
                                        :text-color="rec.dsBrkfsAf == '1' ? 'white' : ''"
                                        label small>
                                        아침식후
                                    </v-chip>
                                </v-row>
                                <v-divider class="white mt-1"></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-chip
                                        class="px-1 mr-2"
                                        :color="rec.dsLunchBf == '1' ? 'blue105' : ''"
                                        :text-color="rec.dsLunchBf == '1' ? 'white' : ''"
                                        label small>
                                        점심식전
                                    </v-chip>
                                    <v-chip
                                        class="px-1 mr-2"
                                        :color="rec.dsLunchAf == '1' ? 'blue105' : ''"
                                        :text-color="rec.dsLunchAf == '1' ? 'white' : ''"
                                        label small>
                                        점심식후
                                    </v-chip>
                                </v-row>
                                <v-divider class="white mt-1"></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-chip
                                        class="px-1 mr-2"
                                        :color="rec.dsDinerBf == '1' ? 'blue105' : ''"
                                        :text-color="rec.dsDinerBf == '1' ? 'white' : ''"
                                        label small>
                                        저녁식전
                                    </v-chip>
                                    <v-chip
                                        class="px-1 mr-2"
                                        :color="rec.dsDinerAf == '1' ? 'blue105' : ''"
                                        :text-color="rec.dsDinerAf == '1' ? 'white' : ''"
                                        label small>
                                        저녁식후
                                    </v-chip>
                                </v-row>
                                <v-divider class="white mt-1"></v-divider>
                                <v-row class="pa-0" no-gutters>
                                    <v-chip
                                        class="px-1 mr-2"
                                        :color="rec.dsBedBf == '1' ? 'blue105' : ''"
                                        :text-color="rec.dsBedBf == '1' ? 'white' : ''"
                                        label small>
                                        취침전
                                    </v-chip>
                                    <v-chip
                                        class="px-1 mr-2"
                                        :color="rec.dsNeed == '1' ? 'blue105' : ''"
                                        :text-color="rec.dsNeed == '1' ? 'white' : ''"
                                        label small>
                                        필요시
                                    </v-chip>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-if="doesRecList.length == 0" class="pa-0 tableBB" no-gutters>
                            <v-col class="txtAlgnMid px-2 pt-2" style="padding-bottom: 10px;" cols="12">
                                <span class="fontDotEight">조회된 투약기록이 없습니다.</span>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

import AppYMD from '../cmm/AppYMD.vue';

export default {
    name: 'BnfcrDtl',

    components: {
        AppYMD,
    },

    props: {

    },

    created: function(){

    },

    mounted: function(){
        this.$nextTick(function () {
            if(this.$vuetify.breakpoint.width > 359)
                this.imgWidth = 120
            else
                this.imgWidth = 100

            this.sltBnMmbrPk = this.$route.params.bnMmbrPk
            this.sltBnfcrPk = this.$route.params.bnfcrPk
            this.vCd63 = this.$route.params.vCd63
            this.vCd65 = this.$route.params.vCd65
            this.$parent.$parent.appBarTtl = '수급자 정보'
            //this.sltHypDt = this.$store.getters.getPrsntDt('yyyy-mm-dd')
            this.getMobBnfcrInf(this.sltBnMmbrPk, this.sltBnfcrPk)
        })
    },

    computed: {

    },

    watch:{
        'tab': function (){
            switch (this.tab) {
                case 0:
                    this.getMobBnfcrInf(this.sltBnMmbrPk, this.sltBnfcrPk)
                    break;
                case 1:
                    if(this.sltDt == '')
                        this.getHlthVtlRec(this.sltBnMmbrPk, this.$moment().format('YYYYMMDD'))
                    else
                        this.getHlthVtlRec(this.sltBnMmbrPk, this.sltDt)
                    break;
                case 2:
                    if(this.sltDt == '')
                        this.getDoseRecList(this.sltBnMmbrPk, this.$moment().format('YYYYMMDD'))
                    else
                        this.getDoseRecList(this.sltBnMmbrPk, this.sltDt)
                    break;
                default:
                    break;
            }
        },
    },
        
    methods: {
        // 수급자 목록 조회
        getMobBnfcrInf: function (bnmmbr, bnfcr){
            this.rstBnfcrInf()
            this.fmlyList.splice(0)
            this.$store.commit('setCmmLdrCricle', true)

            http.post('empApp/selModBnfcrInfo', { bnMmbrPk: bnmmbr, bnfcrPk: bnfcr })
                .then((response) => ( this.bnfcrListRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selModBnfcrInfo : ' + error))
        },

        bnfcrListRst: function (res){
            if(res.statusCode == '200'){
                // 수급자 정보 맵핑
                if(res.result.bnfcr != null){
                    if(res.result.photoImg != null)
                        this.bnfcrImg = 'data:image/png;base64,' + res.result.photoImg

                    let cpy = this.vCd63.findIndex( v => v.valcd == res.result.bnfcr.copayRate )
                    if(cpy > -1)
                        this.bnfcrInfo.copayRate = this.vCd63[cpy].valcdnm
                    let chc = this.vCd65.findIndex( v => v.valcd == res.result.bnfcr.entStcd )
                    if(chc > -1)
                        this.bnfcrInfo.entStcdNm = this.vCd65[chc].valcdnm

                    this.bnfcrInfo.name = res.result.bnfcr.name
                    this.bnfcrInfo.age = res.result.bnfcr.age
                    if(res.result.bnfcr.gndr == 'M')
                        this.bnfcrInfo.gndr = '남'
                    else if(res.result.bnfcr.gndr == 'F')
                        this.bnfcrInfo.gndr = '여'

                    if(res.result.bnfcr.rsdntBirth != '')
                        this.bnfcrInfo.rsdntBirth = this.$moment(res.result.bnfcr.rsdntBirth, 'YYYYMMDD').format('YYYY.MM.DD')
                    if(res.result.bnfcr.birth != '')
                        this.bnfcrInfo.birth = this.$moment(res.result.bnfcr.birth, 'YYYYMMDD').format('YYYY.MM.DD')
                    if(res.result.bnfcr.entDt != '')
                        this.bnfcrInfo.entDt = this.$moment(res.result.bnfcr.entDt, 'YYYYMMDD').format('YYYY.MM.DD')
                    if(res.result.bnfcr.entHlthChdt != '')
                        this.bnfcrInfo.entHlthChdt = this.$moment(res.result.bnfcr.entHlthChdt, 'YYYYMMDD').format('YYYY.MM.DD')
                    if(res.result.bnfcr.acknwPrdStrt != '')
                        this.bnfcrInfo.acknwPrdStrt = this.$moment(res.result.bnfcr.acknwPrdStrt, 'YYYYMMDD').format('YYYY.MM.DD')
                    if(res.result.bnfcr.acknwPrdEnd != '')
                        this.bnfcrInfo.acknwPrdEnd = this.$moment(res.result.bnfcr.acknwPrdEnd, 'YYYYMMDD').format('YYYY.MM.DD')

                    this.bnfcrInfo.entTm = res.result.bnfcr.entTmHh + ':' + res.result.bnfcr.entTmMm
                    this.bnfcrInfo.lvnRm = res.result.bnfcr.lvnRm
                    this.bnfcrInfo.zip = res.result.bnfcr.zip
                    this.bnfcrInfo.addr = res.result.bnfcr.addr
                    this.bnfcrInfo.addrDtl = res.result.bnfcr.addrDtl
                    this.bnfcrInfo.majorDsss = res.result.bnfcr.majorDsss
                    this.bnfcrInfo.rmrks = res.result.bnfcr.rmrks

                    if(res.result.bnfcr.acknwNum2 == null) res.result.bnfcr.acknwNum2 = ''
                    if(res.result.bnfcr.acknwNum2 == '')
                        this.bnfcrInfo.acknwNum = res.result.bnfcr.acknwNum1
                    else
                        this.bnfcrInfo.acknwNum = res.result.bnfcr.acknwNum1 + '-' + res.result.bnfcr.acknwNum2

                    if(res.result.bnfcr.acknwRtng == '99')
                        this.bnfcrInfo.acknwRtng = '등급외'
                    else
                        this.bnfcrInfo.acknwRtng = res.result.bnfcr.acknwRtng + '등급'
                    if(res.result.bnfcr.mealSprtYn == '1')
                        this.bnfcrInfo.mealSprtYn = true
                    if(res.result.bnfcr.snackSprtYn == '1')
                        this.bnfcrInfo.snackSprtYn = true

                    if(res.result.bnfcr.celphn_1 != '')
                        this.bnfcrInfo.celphn += res.result.bnfcr.celphn_1
                    if(res.result.bnfcr.celphn_2 != '')
                        this.bnfcrInfo.celphn += '-' + res.result.bnfcr.celphn_2
                    if(res.result.bnfcr.celphn_3 != '')
                        this.bnfcrInfo.celphn += '-' + res.result.bnfcr.celphn_3

                    if(res.result.bnfcr.tel_1 != '')
                        this.bnfcrInfo.tel += res.result.bnfcr.tel_1
                    if(res.result.bnfcr.tel_2 != '')
                        this.bnfcrInfo.tel += '-' + res.result.bnfcr.tel_2
                    if(res.result.bnfcr.tel_3 != '')
                        this.bnfcrInfo.tel += '-' + res.result.bnfcr.tel_3
                    
                }

                // 주 보호자 정보 맵핑
                if(Object.keys(res.result.galFmly).length > 0){
                    this.galFmlyInfo.name = res.result.galFmly.name
                    this.galFmlyInfo.rltns = res.result.galFmly.rltns
                    this.galFmlyInfo.zip = res.result.galFmly.zip
                    this.galFmlyInfo.addr = res.result.galFmly.addr
                    this.galFmlyInfo.addrDtl = res.result.galFmly.addrDtl

                    if(res.result.galFmly.rsdntBirth != '')
                        this.galFmlyInfo.rsdntBirth = this.$moment(res.result.galFmly.rsdntBirth, 'YYYYMMDD').format('YYYY.MM.DD')

                    if(res.result.galFmly.celphn_1 != '')
                        this.galFmlyInfo.celphn += res.result.galFmly.celphn_1
                    if(res.result.galFmly.celphn_2 != '')
                        this.galFmlyInfo.celphn += '-' + res.result.galFmly.celphn_2
                    if(res.result.galFmly.celphn_3 != '')
                        this.galFmlyInfo.celphn += '-' + res.result.galFmly.celphn_3
                }

                // 보호자 정보 맵핑
                if(Array.isArray(res.result.fmlyList)){
                    res.result.fmlyList.forEach(itm => {
                        itm.celphn = ''
                        if(itm.celphn_1 != '')
                            itm.celphn += itm.celphn_1
                        if(itm.celphn_2 != '')
                            itm.celphn += '-' + itm.celphn_2
                        if(itm.celphn_3 != '')
                            itm.celphn += '-' + itm.celphn_3
                    });

                    this.fmlyList = res.result.fmlyList
                }
            }
            this.$store.commit('setCmmLdrCricle', false)
        },

        // 건강 바이탈 기록 다건 조회
        getHlthVtlRec: function (bnmmbr, sltDt){
            this.hlthVtlRecList.splice(0)
            this.$store.commit('setCmmLdrCricle', true)

            http.post('empApp/selHlthVtlRecList', { bnMmbrPk: bnmmbr, recDt: sltDt })
                .then((response) => ( this.hlthVtlRecRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selHlthVtlRecList : ' + error))
        },

        hlthVtlRecRst: function (res){
            if(res.statusCode == '200'){
                res.result.list.forEach(itm => {
                    if(itm.recDt == null) itm.recDt = ''
                    if(itm.recDt != '')
                        itm.recDtDot = this.$moment(itm.recDt, 'YYYYMMDD').format('YYYY.MM.DD')
                    else
                        itm.recDtDot = ''
                });

                this.hlthVtlRecList = res.result.list
            }

            this.$store.commit('setCmmLdrCricle', false)
        },

        // 수급자 투약기록 조회
        getDoseRecList: function (bnmmbr, sltDt){
            this.doesRecList.splice(0)
            this.$store.commit('setCmmLdrCricle', true)

            http.post('empApp/selDoseRecList', { bnMmbrPk: bnmmbr, inqYMD: sltDt })
                .then((response) => ( this.doseRecRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selDoseRecList : ' + error))
        },

        doseRecRst: function (res){
            if(res.statusCode == '200')
                this.doesRecList = res.result.list

            this.$store.commit('setCmmLdrCricle', false)
        },

        getHypDt: function (v){
            this.sltDt = this.$moment(v, 'YYYY-MM-DD').format('YYYYMMDD')

            switch (this.tab) {
                case 1:
                    this.getHlthVtlRec(this.sltBnMmbrPk, this.sltDt)
                    break;
                case 2:
                    this.getDoseRecList(this.sltBnMmbrPk, this.sltDt)
                    break;
                default:
                    break;
            }
        },

        rstBnfcrInf: function (){
            Object.keys(this.bnfcrInfo).forEach(itm => {
                if(itm == 'age')
                    this.bnfcrInfo[itm] = 0
                else
                    this.bnfcrInfo[itm] = ''
            });

            Object.keys(this.galFmlyInfo).forEach(itm => {
                this.galFmlyInfo[itm] = ''
            });
        },
    },

    data: () => ({
        tab: 0,
        sltDt: '',
        imgWidth: 100,
        bnfcrImg: '/icons/circle_no_image.svg',
        sltBnMmbrPk: 0,
        sltBnfcrPk: 0,
        bnfcrInfo: {
            name: '', gndr: '', rsdntBirth: '', age: 0, birth: '', entStcdNm: '', entDt: '', entTm: '',
            lvnRm: '', acknwNum: '', entHlthChdt: '', acknwRtng: '', mealSprtYn: false, snackSprtYn: false,
            copayRate: '', acknwPrdStrt: '', acknwPrdEnd: '', celphn: '', tel: '', zip: '', addr: '', addrDtl: '',
            majorDsss: '', rmrks: '', lvDt: '',
        },
        galFmlyInfo: {
            name: '', rltns: '', rsdntBirth: '', celphn: '', zip: '', addr: '', addrDtl: '',
        },
        fmlyList: [],
        hlthVtlRecList: [],
        doesRecList: [],
        vCd63: [],
        vCd65: [],
        tabMenu: [
            { tbNm: '기본항목' }, { tbNm: '바이탈' }, { tbNm: '투약기록' }
        ],
    }),
};
</script>